import { styled } from '@material-ui/core/styles';
import FPLink from 'UI/components/atoms/FPLink';

export const PlainLink = styled(FPLink)({
  backgroundColor: 'inherit',
  padding: 0
});
